export default async function GetAllClientId(clientId,fromdate,todate) {
    // let url = 'https://localhost:7088'+ `/api/LeadData/GetAllclients?clientId=${clientId}&fromdate=${fromdate}&todate=${todate}`
    let url = window.RealestateService + `/api/LeadData/GetAllclients?clientId=${clientId}&fromdate=${fromdate}&todate=${todate}`
    let response = {}

    let head = {
        "Content-Type": "application/json",
        'accept': '*/*'
    }
    response = await fetch(url, {
        method: "GET",
        headers: head,
        // body: JSON.stringify(senddata)
    }).then(res => res.json()).then(response)
    return response;
}